import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const createSkillMap = api(async function createSkillMap({
    name,
    description,
    startingPoint,
    sourceSkillMapId,
    regimeId,
}) {
    return mutate(
        gql`
            mutation CreateSkillMap(
                $name: String!
                $description: String
                $startingPoint: String!
                $sourceSkillMapId: String
                $regimeId: String
            ) {
                createSkillMap(
                    name: $name
                    description: $description
                    startingPoint: $startingPoint
                    sourceSkillMapId: $sourceSkillMapId
                    regimeId: $regimeId
                ) {
                    id
                    name
                    description
                    trades
                }
            }
        `,
        { name, description, startingPoint, sourceSkillMapId, regimeId },
        { returns: "createSkillMap" }
    )
})
